import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { EventStatusTypes } from '__generated__/graphql/legacy/graphql';

import styles from './NoEventEmptyState.module.scss';
import EmptyState from '../EmptyState';

const cx = classNames.bind(styles);

interface NoEventEmptyStateProps {
  eventStatus: EventStatusTypes;
}

const NoEventEmptyState: React.FC<NoEventEmptyStateProps> = ({
  eventStatus,
}) => {
  const { t } = useTranslation();
  const isPastEvent = eventStatus === EventStatusTypes.Expired;

  return (
    <>
      {isPastEvent ? (
        <div className={cx('no-event-empty-state__container')}>
          <span>
            {t(
              'components-events-no_past_events',
              'No previous events to display.'
            )}
          </span>
        </div>
      ) : (
        <EmptyState />
      )}
    </>
  );
};

export default NoEventEmptyState;
